import React, { useMemo, useState } from "react";
import { ReceiptText, CheckCircle2, Clock, CalendarClock, ChevronDown, FileDown, Pencil, Plus, Trash2, FileBarChart2, X, MessageCircle, BarChart3, Landmark, HandCoins, Paperclip, ReceiptText as ReceiptIcon, Users, ExternalLink, AlertTriangle, Ban, QrCode } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { useApp, formatBRL, formatDate } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { useToast } from "../hooks/use-toast";
import { gerarFaturaPDF } from "../utils/faturaPdf";
import { gerarInformeRendimentosLotePDF } from "../utils/relatorioLotePdf";
import Autocomplete from "../components/Autocomplete";
import ReceberModal from "../components/ReceberModal";
import { RescisaoAprovarDialog, isFaturaRescisao } from "../components/RescisaoAprovarDialog";
import { PixFaturaDialog } from "../components/PixFaturaDialog";
import { BaixaPixDialog } from "../components/BaixaPixDialog";
import { HistoricoBoletos } from "../components/HistoricoBoletos";

const inputCls = "w-full px-3 py-2 rounded-lg border border-slate-200 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm";
const mesLabel = (mes) => {
  const [y, m] = mes.split("-");
  const nomes = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  return `${nomes[Number(m) - 1]}/${y}`;
};
const uid = () => Math.random().toString(36).slice(2, 10);
const hoje = () => new Date().toISOString().slice(0, 10);

const Faturas = () => {
  const { faturas, residentes, residentesAtivos, produtos, contasReceber, salvarContaReceber, excluirContaReceber, getResidente, getProduto, marcarFaturaPaga, salvarFaturaAjuste, excluirFaturaAjuste, excluirFatura, restaurarFatura, baixaMassaFaturas, excluirMassaFaturas, enviarFaturaWhatsapp, enviarFaturaWhatsappPdf, gerarBoletoFatura, cancelarBoletoFatura, boletos, historicoBoletos, isAdmin, empresa, janelaConsumo } = useApp();
  const { toast } = useToast();
  const [expanded, setExpanded] = useState(null);
  const [enviandoWa, setEnviandoWa] = useState(null);
  const [enviandoPdf, setEnviandoPdf] = useState(null);
  const [gerandoBoleto, setGerandoBoleto] = useState(null);
  const [filtroResidente, setFiltroResidente] = useState("todos");
  const [showCanceladas, setShowCanceladas] = useState(false);
  const [excluirAlvo, setExcluirAlvo] = useState(null);
  const [selFat, setSelFat] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [fStatus, setFStatus] = useState("todas");
  const [fTipo, setFTipo] = useState("todos");
  const [busca, setBusca] = useState("");
  const mesAtualIni = new Date().toISOString().slice(0, 8) + "01";
  const mesAtualFim = (() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().slice(0, 10); })();
  const [dIni, setDIni] = useState(mesAtualIni);
  const [dFim, setDFim] = useState(mesAtualFim);
  const noMesAtual = dIni === mesAtualIni && dFim === mesAtualFim;

  // NOVO (seletor) + modal de recebível
  const [novoOpen, setNovoOpen] = useState(false);
  const [receberOpen, setReceberOpen] = useState(false);
  const [receberEditing, setReceberEditing] = useState(null);

  // Modal de edição de fatura
  const [editOpen, setEditOpen] = useState(false);
  const [editFatura, setEditFatura] = useState(null);
  const [novoResidente, setNovoResidente] = useState("");
  const [novoMes, setNovoMes] = useState("");
  const [manual, setManual] = useState([]);
  const [observacao, setObservacao] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [addProd, setAddProd] = useState("");
  const [addQtd, setAddQtd] = useState(1);
  const [addServ, setAddServ] = useState("");
  const [addServVal, setAddServVal] = useState("");
  const [addMensDesc, setAddMensDesc] = useState("");
  const [addMensVal, setAddMensVal] = useState("");

  const [loteOpen, setLoteOpen] = useState(false);
  const anoAtual = new Date().getFullYear();
  const [anoLote, setAnoLote] = useState(String(anoAtual));

  const mesAtual = new Date().toISOString().slice(0, 7);
  const hojeISO = hoje();
  const recPend = (contasReceber || []).filter((c) => c.status === "pendente");

  // ---------- CARDS (somam faturas + recebíveis avulsos) ----------
  const totalAbertoFat = faturas.filter((f) => !f.paga && !f.cancelada).reduce((s, f) => s + f.total, 0);
  const divergentes = useMemo(() => faturas.filter((f) => !f.paga && !f.cancelada && f.totalBoleto != null && f.totalCalculado != null && Math.abs(f.totalBoleto - f.totalCalculado) >= 0.01), [faturas]);
  const totalAbertoRec = recPend.reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const totalAberto = totalAbertoFat + totalAbertoRec;

  const recebidoFat = faturas.filter((f) => f.paga && !f.cancelada && f.mes === mesAtual).reduce((s, f) => s + f.total, 0);
  const recebidoRec = (contasReceber || []).filter((c) => c.status === "recebido" && (c.dataRecebimento || "").slice(0, 7) === mesAtual).reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const recebidoMes = recebidoFat + recebidoRec;

  const inadimplenciaFat = faturas.filter((f) => !f.paga && !f.cancelada && f.vencimento < hojeISO).reduce((s, f) => s + f.total, 0);
  const inadimplenciaRec = recPend.filter((c) => c.vencimento && c.vencimento < hojeISO).reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const inadimplencia = inadimplenciaFat + inadimplenciaRec;

  // ---------- LISTA UNIFICADA ----------
  const itensNorm = useMemo(() => {
    const arr = [];
    faturas.forEach((f) => {
      if (showCanceladas ? !f.cancelada : f.cancelada) return;
      const res = getResidente(f.residenteId);
      arr.push({ tipo: "fatura", key: `F_${f.key}`, fatura: f, nome: res?.nome || "—", pagador: res?.nome || "", categoria: "Residente", vencimento: f.vencimento || "", valor: f.total, pago: !!f.paga });
    });
    if (!showCanceladas) {
      (contasReceber || []).forEach((c) => {
        arr.push({ tipo: "receber", key: `R_${c.id}`, conta: c, nome: c.descricao, pagador: c.pagador || "", categoria: c.categoria || "Outros", vencimento: c.vencimento || "", valor: Number(c.valor) || 0, pago: c.status === "recebido" });
      });
    }
    return arr;
  }, [faturas, contasReceber, showCanceladas, residentes]);

  const itensFiltrados = useMemo(() => {
    const b = busca.trim().toLowerCase();
    return itensNorm.filter((it) => {
      if (fTipo === "faturas" && it.tipo !== "fatura") return false;
      if (fTipo === "avulsos" && it.tipo !== "receber") return false;
      if (it.tipo === "fatura" && !(filtroResidente === "todos" || it.fatura.residenteId === filtroResidente)) return false;
      if (filtroResidente !== "todos" && it.tipo === "receber") return false;
      const atrasada = !it.pago && it.vencimento && it.vencimento < hojeISO;
      const statusOk = fStatus === "todas"
        || (fStatus === "recebida" && it.pago)
        || (fStatus === "aberto" && !it.pago)
        || (fStatus === "atrasada" && atrasada);
      if (!statusOk) return false;
      if (dIni && (it.vencimento || "") < dIni) return false;
      const antecipadaNoMesAtual = noMesAtual && it.tipo === "fatura" && it.fatura.antecipada && !it.pago;
      if (dFim && (it.vencimento || "") > dFim && !antecipadaNoMesAtual) return false;
      if (b && !(it.nome.toLowerCase().includes(b) || (it.pagador || "").toLowerCase().includes(b))) return false;
      return true;
    }).sort((a, b2) => {
      if (a.pago !== b2.pago) return a.pago ? 1 : -1; // pagas/recebidas ao final
      return a.pago ? (b2.vencimento || "").localeCompare(a.vencimento || "") : (a.vencimento || "").localeCompare(b2.vencimento || "");
    });
  }, [itensNorm, fTipo, filtroResidente, fStatus, dIni, dFim, busca, hojeISO, noMesAtual]);

  const totalPaginas = Math.max(1, Math.ceil(itensFiltrados.length / pageSize));
  const pageSafe = Math.min(page, totalPaginas);
  const itensPagina = itensFiltrados.slice((pageSafe - 1) * pageSize, pageSafe * pageSize);
  const faturasNaPagina = itensPagina.filter((it) => it.tipo === "fatura");

  const residentesComFatura = useMemo(() => {
    const ids = new Set(faturas.map((f) => f.residenteId));
    return residentes.filter((r) => ids.has(r.id)).sort((a, b) => a.nome.localeCompare(b.nome));
  }, [faturas, residentes]);

  // Gráfico: recebimentos por mês (faturas + recebíveis)
  const chartData = useMemo(() => {
    const byMes = {};
    const bump = (mes, pago, valor) => {
      if (!mes) return;
      if (!byMes[mes]) byMes[mes] = { mes, pago: 0, aberto: 0 };
      if (pago) byMes[mes].pago += valor; else byMes[mes].aberto += valor;
    };
    faturas.forEach((f) => { if (!f.cancelada) bump(f.mes, f.paga, f.total); });
    (contasReceber || []).forEach((c) => bump((c.vencimento || "").slice(0, 7), c.status === "recebido", Number(c.valor) || 0));
    return Object.values(byMes)
      .sort((a, b) => a.mes.localeCompare(b.mes))
      .slice(-12)
      .map((d) => ({ label: mesLabel(d.mes), pago: +d.pago.toFixed(2), aberto: +d.aberto.toFixed(2) }));
  }, [faturas, contasReceber]);

  const enviarWa = async (f) => {
    setEnviandoWa(f.key);
    try {
      const res = await enviarFaturaWhatsapp(f.residenteId, f.mes, f.total);
      if (res.status === "enviado") toast({ title: "Fatura enviada no WhatsApp", description: `Para ${res.nome} · ${res.telefone}` });
      else if (res.status === "pausado") toast({ title: "Envio pausado", description: "Credenciais do WhatsApp não configuradas." });
      else toast({ title: "Não foi possível enviar", description: res.erro || "Verifique o número do responsável." });
    } catch (e) { toast({ title: "Falha ao enviar", description: e?.response?.data?.detail || "Erro ao enviar no WhatsApp." }); }
    finally { setEnviandoWa(null); }
  };

  const enviarWaPdf = async (f) => {
    setEnviandoPdf(f.key);
    try {
      const res = getResidente(f.residenteId);
      const jc = janelaConsumo ? janelaConsumo(f.residenteId, f.mes) : null;
      const dm = (dt) => dt ? `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}` : "";
      const periodo = jc ? `${dm(jc.inicio)} a ${dm(jc.fim)}` : "";
      const dataUri = gerarFaturaPDF({ empresa, residente: res, fatura: f, getProduto, periodo, modo: "datauri" });
      const base64 = dataUri.split(",")[1];
      const r = await enviarFaturaWhatsappPdf(f.residenteId, f.mes, f.total, base64);
      if (r.status === "enviado") toast({ title: "Fatura (PDF) enviada no WhatsApp", description: `Para ${r.nome} · ${r.telefone}` });
      else if (r.status === "pausado") toast({ title: "Envio pausado", description: "Credenciais do WhatsApp não configuradas." });
      else toast({ title: "Não foi possível enviar o PDF", description: r.erro || "Verifique o template fatura_pdf na Meta." });
    } catch (e) { toast({ title: "Falha ao enviar o PDF", description: e?.response?.data?.detail || "Erro." }); }
    finally { setEnviandoPdf(null); }
  };

  const [cancelandoBoleto, setCancelandoBoleto] = useState(null);
  const cancelarBoleto = async (f) => {
    const bol = boletos?.[`${f.residenteId}_${f.mes}`];
    if (!window.confirm(`Cancelar no Asaas o boleto de ${formatBRL(bol?.valor || f.total)} (venc. ${formatDate(bol?.vencimento || f.vencimento)})?\n\nA cobrança deixa de existir para o responsável e a fatura volta a ficar "sem boleto". Nenhum novo boleto será emitido.`)) return;
    setCancelandoBoleto(f.key);
    try {
      await cancelarBoletoFatura(f.residenteId, f.mes);
      toast({ title: "Boleto cancelado no Asaas", description: "A fatura permanece em aberto, sem boleto." });
    } catch (e) {
      toast({ title: "Não foi possível cancelar", description: e?.response?.data?.detail || "Erro ao cancelar no Asaas." });
    } finally { setCancelandoBoleto(null); }
  };

  const gerarBoleto = async (f) => {
    setGerandoBoleto(f.key);
    try {
      const r = await gerarBoletoFatura(f.residenteId, f.mes);
      const isSandbox = /sandbox/i.test(`${r.bankSlipUrl || ""}${r.invoiceUrl || ""}`);
      if (isSandbox) {
        toast({ title: "Boleto criado em AMBIENTE DE TESTE (Sandbox)", description: "Ele NÃO aparece na sua conta real do Asaas. É preciso configurar as credenciais de PRODUÇÃO do Asaas no deploy." });
        return;
      }
      const wa = r.whatsapp || {}; const email = r.email || {};
      const partes = [`Boleto gerado (venc. ${formatDate(r.vencimento)})`];
      if (email.status === "enviado") partes.push(`e-mail enviado p/ ${email.para}`);
      else if (email.status === "pausado") partes.push("e-mail não enviado (responsável sem e-mail)");
      if (wa.boleto === "enviado" || wa.fatura === "enviado") partes.push("WhatsApp enviado");
      toast({ title: "Boleto criado no Asaas", description: partes.join(" · ") });
    } catch (e) { toast({ title: "Falha ao gerar boleto", description: e?.response?.data?.detail || "Erro ao criar o boleto no Asaas." }); }
    finally { setGerandoBoleto(null); }
  };

  const anosDisponiveis = useMemo(() => {
    const set = new Set([String(anoAtual)]);
    faturas.forEach((f) => set.add((f.mes || "").slice(0, 4)));
    return [...set].filter(Boolean).sort((a, b) => b.localeCompare(a));
  }, [faturas, anoAtual]);

  const abrirNova = () => {
    setEditFatura(null);
    setNovoResidente(residentesAtivos[0]?.id || "");
    setNovoMes(`${anoAtual}-${String(new Date().getMonth() + 1).padStart(2, "0")}`);
    setManual([]); setObservacao(""); resetAdders();
    setEditOpen(true);
  };
  const abrirEdicao = (f) => {
    setEditFatura(f);
    setManual((f.manual || []).map((m) => ({ ...m, id: m.id || uid() })));
    setObservacao(f.observacao || ""); resetAdders();
    setEditOpen(true);
  };
  const resetAdders = () => { setAddProd(""); setAddQtd(1); setAddServ(""); setAddServVal(""); setAddMensDesc(""); setAddMensVal(""); };

  const residenteAlvo = editFatura ? editFatura.residenteId : novoResidente;
  const mesAlvo = editFatura ? editFatura.mes : novoMes;

  const addProduto = () => {
    const prod = getProduto(addProd);
    if (!prod || addQtd <= 0) return;
    const valor = +((Number(prod.precoVenda) || 0) * Number(addQtd)).toFixed(2);
    setManual((m) => [...m, { id: uid(), parte: "item", descricao: `${prod.nome} (${addQtd} ${prod.unidade})`, valor, produtoId: prod.id, quantidade: Number(addQtd) }]);
    setAddProd(""); setAddQtd(1);
  };
  const addServico = () => {
    if (!addServ.trim() || !addServVal) return;
    setManual((m) => [...m, { id: uid(), parte: "item", descricao: addServ.trim(), valor: parseFloat(addServVal) || 0 }]);
    setAddServ(""); setAddServVal("");
  };
  const addMensal = () => {
    if (!addMensDesc.trim() || !addMensVal) return;
    setManual((m) => [...m, { id: uid(), parte: "mensal", descricao: addMensDesc.trim(), valor: parseFloat(addMensVal) || 0 }]);
    setAddMensDesc(""); setAddMensVal("");
  };
  const removerManual = (id) => setManual((m) => m.filter((x) => x.id !== id));

  const baseFatura = useMemo(() => {
    if (editFatura) {
      const extrasTotal = (editFatura.extras || []).reduce((s, e) => s + (Number(e.valor) || 0), 0);
      const itensTotal = (editFatura.itens || []).reduce((s, it) => s + (Number(it.valorCobrado) || 0), 0);
      return { extras: editFatura.extras || [], itens: editFatura.itens || [], total: extrasTotal + itensTotal };
    }
    return { extras: [], itens: [], total: 0 };
  }, [editFatura]);

  const totalManual = manual.reduce((s, m) => s + (Number(m.valor) || 0), 0);
  const totalPreview = baseFatura.total + totalManual;

  const salvar = async () => {
    if (!residenteAlvo || !mesAlvo) { toast({ title: "Selecione residente e mês" }); return; }
    if (!editFatura && manual.length === 0 && !observacao.trim()) { toast({ title: "Adicione ao menos um item à fatura avulsa" }); return; }
    setSalvando(true);
    try {
      await salvarFaturaAjuste(residenteAlvo, mesAlvo, manual, observacao);
      toast({ title: "Fatura atualizada" });
      setEditOpen(false);
    } finally { setSalvando(false); }
  };

  const limparAjuste = async (f) => { await excluirFaturaAjuste(f.residenteId, f.mes); toast({ title: "Ajustes removidos da fatura" }); setEditOpen(false); };
  const gerarLote = () => { gerarInformeRendimentosLotePDF({ empresa, residentes, faturas, ano: anoLote }); setLoteOpen(false); };

  const confirmarExclusao = async () => {
    if (!excluirAlvo) return;
    await excluirFatura(excluirAlvo.key);
    toast({ title: "Fatura excluída", description: "Você pode restaurá-la em 'Mostrar excluídas'." });
    setExcluirAlvo(null); setExpanded(null);
  };
  const restaurar = async (f) => { await restaurarFatura(f.key); toast({ title: "Fatura restaurada" }); };

  const toggleSelFat = (key) => setSelFat((s) => s.includes(key) ? s.filter((x) => x !== key) : [...s, key]);
  const toggleAllFat = () => setSelFat((s) => s.length === faturasNaPagina.length ? [] : faturasNaPagina.map((it) => it.fatura.key));
  const baixarSelFat = async () => {
    const pend = selFat.filter((k) => !faturas.find((f) => f.key === k)?.paga);
    if (pend.length === 0) { toast({ title: "Selecione faturas em aberto" }); return; }
    await baixaMassaFaturas(pend); toast({ title: `${pend.length} fatura(s) marcada(s) como paga(s)` }); setSelFat([]);
  };
  const excluirSelFat = async () => {
    if (selFat.length === 0) return;
    await excluirMassaFaturas(selFat); toast({ title: `${selFat.length} fatura(s) excluída(s)` }); setSelFat([]);
  };

  // Recebível: ações
  const [recBusy, setRecBusy] = useState(null);
  const marcarRecebido = async (c, recebido) => {
    if (!c.id || recBusy) return;
    setRecBusy(c.id);
    try {
      await salvarContaReceber({ ...c, status: recebido ? "recebido" : "pendente", dataRecebimento: recebido ? (c.dataRecebimento || hoje()) : "" });
      toast({ title: recebido ? "Recebível marcado como recebido" : "Recebível reaberto" });
    } finally { setRecBusy(null); }
  };
  const verAnexo = (dataUrl) => {
    if (!dataUrl) return;
    const w = window.open(); if (!w) return;
    w.document.write(dataUrl.startsWith("data:application/pdf") ? `<iframe src="${dataUrl}" style="border:0;width:100%;height:100vh"></iframe>` : `<img src="${dataUrl}" style="max-width:100%" />`);
  };

  const abrirReceber = (c) => { setReceberEditing(c || null); setReceberOpen(true); };

  return (
    <div className="space-y-6" data-testid="faturas-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Faturas (Contas a Receber)</h1>
          <p className="text-slate-400 text-sm mt-0.5">Mensalidades, serviços, produtos, ajustes e recebíveis avulsos — tudo em uma lista</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="gap-2" onClick={() => setLoteOpen(true)} data-testid="relatorio-lote-btn"><FileBarChart2 className="w-4 h-4" /> Informe de Rendimentos</Button>
          <Button className="bg-blue-600 hover:bg-blue-700 gap-2" onClick={() => setNovoOpen(true)} data-testid="novo-btn"><Plus className="w-4 h-4" /> NOVO</Button>
        </div>
      </div>

      {divergentes.length > 0 && (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 flex items-start gap-3" data-testid="divergencias-banner">
          <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="font-semibold">{divergentes.length === 1 ? "1 boleto emitido com valor diferente da fatura calculada" : `${divergentes.length} boletos emitidos com valor diferente da fatura calculada`}</p>
            <ul className="mt-1 space-y-0.5 text-xs">
              {divergentes.slice(0, 6).map((f) => (
                <li key={f.key} data-testid={`divergencia-item-${f.key}`}>
                  <button type="button" className="hover:underline font-medium" onClick={() => setExpanded(`F_${f.key}`)}>{getResidente(f.residenteId)?.nome || "—"}</button> · {mesLabel(f.mes)}: boleto <b>{formatBRL(f.totalBoleto)}</b> × fatura <b>{formatBRL(f.totalCalculado)}</b>
                </li>
              ))}
              {divergentes.length > 6 && <li>… e mais {divergentes.length - 6}.</li>}
            </ul>
            <p className="mt-1.5 text-xs">Abra a fatura e use <b>Gerar novamente</b> (cancela o boleto antigo e emite o correto) ou <b>Cancelar boleto</b>.</p>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="painel-caixa">
        <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">
          <p className="text-sm text-slate-400">Recebido no mês</p>
          <p className="text-2xl font-bold text-emerald-600 mt-1" data-testid="caixa-recebido">{formatBRL(recebidoMes)}</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">
          <p className="text-sm text-slate-400">A receber (inclui atrasadas)</p>
          <p className="text-2xl font-bold text-amber-600 mt-1" data-testid="caixa-receber">{formatBRL(totalAberto)}</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">
          <p className="text-sm text-slate-400">Inadimplência (vencidas)</p>
          <p className="text-2xl font-bold text-red-600 mt-1" data-testid="caixa-inadimplencia">{formatBRL(inadimplencia)}</p>
        </div>
      </div>


      {/* Filtros */}
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          <div className="w-full sm:w-56">
            <input className={inputCls} placeholder="Buscar por nome/descrição/pagador..." value={busca} onChange={(e) => { setBusca(e.target.value); setPage(1); }} data-testid="fatura-busca" />
          </div>
          <div className="w-36"><Select value={fTipo} onValueChange={(v) => { setFTipo(v); setPage(1); }}>
            <SelectTrigger data-testid="filtro-tipo-receber"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos os tipos</SelectItem>
              <SelectItem value="faturas">Faturas de residentes</SelectItem>
              <SelectItem value="avulsos">Recebíveis avulsos</SelectItem>
            </SelectContent>
          </Select></div>
          <div className="w-52">
            <Select value={filtroResidente} onValueChange={(v) => { setFiltroResidente(v); setPage(1); }}>
              <SelectTrigger data-testid="filtro-residente-fatura"><SelectValue placeholder="Filtrar por residente" /></SelectTrigger>
              <SelectContent className="max-h-72">
                <SelectItem value="todos">Todos os residentes</SelectItem>
                {residentesComFatura.map((r) => <SelectItem key={r.id} value={r.id}>{r.nome}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="w-36"><Select value={fStatus} onValueChange={(v) => { setFStatus(v); setPage(1); }}>
            <SelectTrigger data-testid="filtro-status-fatura"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="todas">Todas</SelectItem>
              <SelectItem value="aberto">A receber</SelectItem>
              <SelectItem value="atrasada">Atrasadas</SelectItem>
              <SelectItem value="recebida">Recebidas</SelectItem>
            </SelectContent>
          </Select></div>
          <div className="flex items-center gap-1.5"><label className="text-xs text-slate-500">De</label>
            <input type="date" className="px-2 py-2 rounded-lg border border-slate-200 outline-none focus:border-blue-500 text-sm" value={dIni} onChange={(e) => { setDIni(e.target.value); setPage(1); }} data-testid="fatura-data-ini" />
            <label className="text-xs text-slate-500">até</label>
            <input type="date" className="px-2 py-2 rounded-lg border border-slate-200 outline-none focus:border-blue-500 text-sm" value={dFim} onChange={(e) => { setDFim(e.target.value); setPage(1); }} data-testid="fatura-data-fim" />
            {noMesAtual ? <span className="text-[11px] text-slate-400 ml-1">mês atual — altere as datas para ver outros meses</span>
              : <Button variant="ghost" size="sm" onClick={() => { setDIni(mesAtualIni); setDFim(mesAtualFim); setPage(1); }} data-testid="fatura-mes-atual">Voltar ao mês atual</Button>}
            {(dIni || dFim) && <button onClick={() => { setDIni(""); setDFim(""); }} className="text-slate-400 hover:text-red-500"><X className="w-4 h-4" /></button>}
          </div>
        </div>
        <p className="text-sm text-slate-400">{itensFiltrados.length} registro(s)</p>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => { setShowCanceladas((v) => !v); setPage(1); setSelFat([]); }}
          data-testid="toggle-canceladas"
          className={`text-xs font-medium px-3 py-1.5 rounded-lg border transition-colors ${showCanceladas ? "bg-red-50 text-red-700 border-red-200" : "bg-white text-slate-500 border-slate-200 hover:bg-slate-50"}`}
        >
          {showCanceladas ? "Ver faturas ativas" : "Mostrar excluídas"}
        </button>
        {!showCanceladas && faturasNaPagina.length > 0 && (
          <label className="flex items-center gap-1.5 text-xs font-medium text-slate-500 px-2">
            <input type="checkbox" checked={selFat.length === faturasNaPagina.length && faturasNaPagina.length > 0} onChange={toggleAllFat} data-testid="select-all-faturas" /> Selecionar faturas da página
          </label>
        )}
      </div>

      {selFat.length > 0 && !showCanceladas && (
        <div className="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-lg px-4 py-2.5" data-testid="faturas-massa-toolbar">
          <span className="text-sm font-medium text-blue-800">{selFat.length} selecionada(s)</span>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 gap-1.5" onClick={baixarSelFat} data-testid="baixa-massa-faturas-btn"><CheckCircle2 className="w-4 h-4" /> Marcar como pagas</Button>
          <Button size="sm" variant="outline" className="gap-1.5 text-red-600 border-red-200 hover:bg-red-50" onClick={excluirSelFat} data-testid="excluir-massa-faturas-btn"><Trash2 className="w-4 h-4" /> Excluir</Button>
          <button className="ml-auto text-slate-400 hover:text-slate-600" onClick={() => setSelFat([])}><X className="w-4 h-4" /></button>
        </div>
      )}

      <div className="space-y-3">
        {itensFiltrados.length === 0 && (
          <div className="bg-white rounded-xl border border-slate-100 p-10 text-center text-slate-400">Nenhum registro encontrado.</div>
        )}
        {itensPagina.map((it) => it.tipo === "fatura"
          ? <FaturaCard key={it.key} it={it} {...{ expanded, setExpanded, showCanceladas, selFat, toggleSelFat, getProduto, getResidente, empresa, isAdmin, enviandoWa, enviandoPdf, gerandoBoleto, enviarWa, enviarWaPdf, gerarBoleto, cancelarBoleto, cancelandoBoleto, abrirEdicao, marcarFaturaPaga, setExcluirAlvo, restaurar, janelaConsumo, boletos, historicoBoletos }} />
          : <ReceberCard key={it.key} it={it} {...{ expanded, setExpanded, abrirReceber, marcarRecebido, excluirContaReceber, verAnexo, toast, recBusy }} />
        )}
      </div>

      <div className="flex items-center justify-between gap-3 pt-2 flex-wrap" data-testid="faturas-paginacao">
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <span>Itens por página:</span>
          <div className="w-24"><Select value={String(pageSize)} onValueChange={(v) => { setPageSize(Number(v)); setPage(1); }}>
            <SelectTrigger data-testid="fatura-page-size"><SelectValue /></SelectTrigger>
            <SelectContent>{[15, 25, 50, 100].map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}</SelectContent>
          </Select></div>
        </div>
        <div className="flex items-center gap-3">
          <Button variant="outline" size="sm" disabled={pageSafe <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))} data-testid="pagina-anterior">Anterior</Button>
          <span className="text-sm text-slate-500">Página {pageSafe} de {totalPaginas}</span>
          <Button variant="outline" size="sm" disabled={pageSafe >= totalPaginas} onClick={() => setPage((p) => Math.min(totalPaginas, p + 1))} data-testid="pagina-proxima">Próxima</Button>
        </div>
      </div>

      {/* NOVO — seletor de tipo */}
      <Dialog open={novoOpen} onOpenChange={setNovoOpen}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-md" data-testid="novo-seletor-modal">
          <DialogHeader><DialogTitle>Novo lançamento</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500 -mt-2">O que você quer lançar?</p>
          <div className="grid grid-cols-1 gap-3 pt-1">
            <button onClick={() => { setNovoOpen(false); abrirNova(); }} data-testid="novo-tipo-fatura"
              className="flex items-center gap-3 p-4 rounded-xl border border-slate-200 hover:border-blue-400 hover:bg-blue-50/40 transition text-left">
              <span className="w-11 h-11 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center"><ReceiptIcon className="w-5 h-5" /></span>
              <span><span className="block font-semibold text-slate-800">Fatura de residente</span><span className="block text-xs text-slate-400">Fatura avulsa com mensalidade, serviços e produtos</span></span>
            </button>
            <button onClick={() => { setNovoOpen(false); abrirReceber(null); }} data-testid="novo-tipo-receber"
              className="flex items-center gap-3 p-4 rounded-xl border border-slate-200 hover:border-emerald-400 hover:bg-emerald-50/40 transition text-left">
              <span className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><HandCoins className="w-5 h-5" /></span>
              <span><span className="block font-semibold text-slate-800">Novo recebível (avulso)</span><span className="block text-xs text-slate-400">Serviço, aluguel, reembolso, convênio, venda etc.</span></span>
            </button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal editar / nova fatura */}
      <Dialog open={editOpen} onOpenChange={setEditOpen}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="editar-fatura-modal">
          <DialogHeader><DialogTitle>{editFatura ? "Editar fatura" : "Nova fatura avulsa"}</DialogTitle></DialogHeader>
          {!editFatura && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-sm text-slate-600 mb-1 block">Residente</label>
                <Autocomplete
                  items={residentesAtivos.map((r) => ({ id: r.id, label: r.nome, sub: r.quarto || "" }))}
                  value={novoResidente} onChange={setNovoResidente}
                  placeholder="Buscar residente..." testid="nova-fatura-residente"
                />
              </div>
              <div>
                <label className="text-sm text-slate-600 mb-1 block">Mês de referência</label>
                <input type="month" className={inputCls} value={novoMes} onChange={(e) => setNovoMes(e.target.value)} data-testid="nova-fatura-mes" />
              </div>
            </div>
          )}
          {editFatura && baseFatura.total > 0 && (
            <div className="rounded-lg bg-slate-50 border border-slate-100 px-3 py-2 text-xs text-slate-500">
              Lançamentos automáticos (mensalidade/13º/consumos): <span className="font-semibold text-slate-700">{formatBRL(baseFatura.total)}</span>
            </div>
          )}
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase mb-1.5">Cobranças mensais (parte 1)</p>
            <div className="space-y-1.5">
              {manual.filter((m) => m.parte === "mensal").map((m) => (
                <div key={m.id} className="flex items-center justify-between bg-white border border-slate-100 rounded-lg px-3 py-1.5 text-sm" data-testid={`manual-item-${m.id}`}>
                  <span className="text-slate-700">{m.descricao}</span>
                  <span className="flex items-center gap-3"><span className="font-medium">{formatBRL(m.valor)}</span>
                    <button onClick={() => removerManual(m.id)} className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button></span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-2 mt-2">
              <input className={inputCls} placeholder="Descrição (ex.: Taxa de matrícula)" value={addMensDesc} onChange={(e) => setAddMensDesc(e.target.value)} data-testid="add-mensal-desc" />
              <input type="number" step="0.01" className={`${inputCls} w-28`} placeholder="R$" value={addMensVal} onChange={(e) => setAddMensVal(e.target.value)} data-testid="add-mensal-valor" />
              <Button variant="outline" className="shrink-0" onClick={addMensal} data-testid="add-mensal-btn"><Plus className="w-4 h-4" /></Button>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase mb-1.5">Materiais, medicamentos e serviços (parte 2)</p>
            <div className="space-y-1.5">
              {manual.filter((m) => m.parte === "item").map((m) => (
                <div key={m.id} className="flex items-center justify-between bg-white border border-slate-100 rounded-lg px-3 py-1.5 text-sm" data-testid={`manual-item-${m.id}`}>
                  <span className="text-slate-700">{m.descricao}</span>
                  <span className="flex items-center gap-3"><span className="font-medium">{formatBRL(m.valor)}</span>
                    <button onClick={() => removerManual(m.id)} className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button></span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-2 mt-2">
              <div className="flex-1">
                <Select value={addProd} onValueChange={setAddProd}>
                  <SelectTrigger data-testid="add-produto-select"><SelectValue placeholder="Adicionar produto da tabela..." /></SelectTrigger>
                  <SelectContent className="max-h-72">
                    {produtos.map((p) => <SelectItem key={p.id} value={p.id}>{p.nome} — {formatBRL(p.precoVenda)}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <input type="number" min="1" className={`${inputCls} w-20`} value={addQtd} onChange={(e) => setAddQtd(parseInt(e.target.value) || 1)} data-testid="add-produto-qtd" />
              <Button variant="outline" className="shrink-0" onClick={addProduto} data-testid="add-produto-btn"><Plus className="w-4 h-4" /></Button>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <input className={inputCls} placeholder="Serviço/material avulso (ex.: Lavanderia)" value={addServ} onChange={(e) => setAddServ(e.target.value)} data-testid="add-servico-desc" />
              <input type="number" step="0.01" className={`${inputCls} w-28`} placeholder="R$" value={addServVal} onChange={(e) => setAddServVal(e.target.value)} data-testid="add-servico-valor" />
              <Button variant="outline" className="shrink-0" onClick={addServico} data-testid="add-servico-btn"><Plus className="w-4 h-4" /></Button>
            </div>
          </div>
          <div>
            <label className="text-sm text-slate-600 mb-1 block">Observações</label>
            <textarea rows={2} className={inputCls} value={observacao} onChange={(e) => setObservacao(e.target.value)} placeholder="Informações adicionais que aparecem na fatura..." data-testid="fatura-observacao" />
          </div>
          <div className="flex items-center justify-between pt-2 border-t border-slate-100">
            <span className="text-sm text-slate-500">Total da fatura</span>
            <span className="text-lg font-bold text-slate-800" data-testid="fatura-total-preview">{formatBRL(totalPreview)}</span>
          </div>
          <DialogFooter className="flex-wrap gap-2">
            {editFatura && ((editFatura.manual || []).length > 0 || editFatura.observacao) && (
              <Button variant="outline" className="text-red-600 border-red-200 hover:bg-red-50 mr-auto" onClick={() => limparAjuste(editFatura)} data-testid="limpar-ajuste-btn">Remover ajustes</Button>
            )}
            <Button variant="outline" onClick={() => setEditOpen(false)}>Cancelar</Button>
            <Button className="bg-blue-600 hover:bg-blue-700" disabled={salvando} onClick={salvar} data-testid="salvar-fatura-btn">{salvando ? "Salvando..." : "Salvar"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal recebível */}
      <ReceberModal open={receberOpen} onOpenChange={setReceberOpen} editing={receberEditing} />

      {/* Confirmar exclusão de fatura */}
      <Dialog open={!!excluirAlvo} onOpenChange={(o) => { if (!o) setExcluirAlvo(null); }}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-md" data-testid="excluir-fatura-modal">
          <DialogHeader><DialogTitle>Excluir fatura</DialogTitle></DialogHeader>
          {excluirAlvo && (
            <p className="text-sm text-slate-600">
              Tem certeza que deseja excluir a fatura de <span className="font-semibold">{getResidente(excluirAlvo.residenteId)?.nome}</span> referente a <span className="font-semibold">{mesLabel(excluirAlvo.mes)}</span> ({formatBRL(excluirAlvo.total)})?
              <br /><br />
              A fatura sairá da lista e não será cobrada. Você pode restaurá-la depois em <span className="font-semibold">"Mostrar excluídas"</span>.
            </p>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setExcluirAlvo(null)}>Cancelar</Button>
            <Button className="bg-red-600 hover:bg-red-700 gap-2" onClick={confirmarExclusao} data-testid="confirmar-excluir-fatura"><Trash2 className="w-4 h-4" /> Excluir fatura</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal relatório em lote */}
      <Dialog open={loteOpen} onOpenChange={setLoteOpen}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-sm" data-testid="lote-modal">
          <DialogHeader><DialogTitle>Informe de Rendimentos (todos)</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">Gera um PDF com o informe anual de rendimentos (mensalidade + 13º de faturas pagas) de todos os residentes, uma seção por residente.</p>
          <div>
            <label className="text-sm text-slate-600 mb-1 block">Ano-base</label>
            <Select value={anoLote} onValueChange={setAnoLote}>
              <SelectTrigger data-testid="lote-ano"><SelectValue /></SelectTrigger>
              <SelectContent>{anosDisponiveis.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setLoteOpen(false)}>Cancelar</Button>
            <Button className="bg-blue-600 hover:bg-blue-700 gap-2" onClick={gerarLote} data-testid="gerar-lote-btn"><FileDown className="w-4 h-4" /> Gerar PDF</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

// ---------- Card de FATURA de residente ----------
const FaturaCard = ({ it, expanded, setExpanded, showCanceladas, selFat, toggleSelFat, getProduto, empresa, isAdmin, enviandoWa, enviandoPdf, gerandoBoleto, enviarWa, enviarWaPdf, gerarBoleto, cancelarBoleto, cancelandoBoleto, abrirEdicao, marcarFaturaPaga, setExcluirAlvo, restaurar, getResidente, janelaConsumo, boletos, historicoBoletos }) => {
  const f = it.fatura;
  const res = getResidente ? getResidente(f.residenteId) : null;
  const isOpen = expanded === it.key;
  const bol = boletos ? boletos[`${f.residenteId}_${f.mes}`] : null;
  const eventosBoleto = historicoBoletos ? historicoBoletos[f.key] : null;
  const [pixOpen, setPixOpen] = useState(false);
  const { baixarFaturaPdf } = useApp();
  const baixarPdf = async (fat, resid) => {
    try { await baixarFaturaPdf(fat.residenteId, fat.mes, `fatura-${(resid?.nome || "residente").toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${fat.mes}.pdf`); }
    catch { gerarFaturaPDF({ empresa, residente: resid, fatura: fat, getProduto, periodo }); }
  };
  const [baixaPixOpen, setBaixaPixOpen] = useState(false);
  const divergente = !!bol && !f.paga && !f.cancelada && f.totalBoleto != null && f.totalCalculado != null && Math.abs(f.totalBoleto - f.totalCalculado) >= 0.01;
  const jc = janelaConsumo ? janelaConsumo(f.residenteId, f.mes) : null;
  const dm = (dt) => dt ? `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}` : "";
  const periodo = jc ? `${dm(jc.inicio)} a ${dm(jc.fim)}` : "";
  const mensalItens = [...(f.extras || []), ...((f.manual || []).filter((m) => m.parte === "mensal"))];
  const materiaisManual = (f.manual || []).filter((m) => m.parte === "item");
  const rescisao = isFaturaRescisao(f);
  const [aprovarOpen, setAprovarOpen] = useState(false);
  return (
    <div className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden" data-testid={`fatura-${f.key}`}>
      {rescisao && <RescisaoAprovarDialog fatura={f} residente={res} open={aprovarOpen} onClose={() => setAprovarOpen(false)} />}
      <PixFaturaDialog fatura={f} residente={res} open={pixOpen} onClose={() => setPixOpen(false)} />
      <BaixaPixDialog fatura={f} residente={res} open={baixaPixOpen} onClose={() => setBaixaPixOpen(false)} />
      <div className="flex items-center">
        {!showCanceladas && (
          <div className="pl-4 shrink-0">
            <input type="checkbox" checked={selFat.includes(f.key)} onChange={() => toggleSelFat(f.key)} data-testid={`select-fatura-${f.key}`} />
          </div>
        )}
        <button onClick={() => setExpanded(isOpen ? null : it.key)} className="flex-1 flex items-center justify-between px-5 py-4 hover:bg-slate-50/60 transition-colors">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center"><ReceiptText className="w-5 h-5" /></div>
            <div className="text-left">
              <p className="font-semibold text-slate-800 flex items-center gap-2">
                {it.nome}
                <span className="text-[10px] font-semibold text-blue-700 bg-blue-50 px-1.5 py-0.5 rounded inline-flex items-center gap-0.5"><Users className="w-3 h-3" /> Residente</span>
                {rescisao && <span className="text-[10px] font-semibold text-orange-700 bg-orange-50 border border-orange-200 px-1.5 py-0.5 rounded" data-testid={`badge-rescisao-${f.key}`}>Rescisão</span>}
                {f.cancelada && <span className="text-[10px] font-semibold text-red-700 bg-red-50 px-1.5 py-0.5 rounded" data-testid={`badge-excluida-${f.key}`}>Excluída</span>}
                {f.antecipada && !f.paga && <span className="text-[10px] font-semibold text-violet-700 bg-violet-50 border border-violet-200 px-1.5 py-0.5 rounded" title="Fatura do próximo mês já fechada (data de fechamento atingida)" data-testid={`badge-antecipada-${f.key}`}>Fechada · próximo mês</span>}
              </p>
              <p className="text-xs text-slate-400 flex items-center gap-1"><CalendarClock className="w-3.5 h-3.5" /> Ref. {mesLabel(f.mes)} · Venc. {formatDate(f.vencimento)}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="font-bold text-slate-800">{formatBRL(f.total)}</p>
              {divergente && <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 border border-amber-200" title={`Boleto ${formatBRL(f.totalBoleto)} ≠ fatura calculada ${formatBRL(f.totalCalculado)}`} data-testid={`divergencia-badge-${f.key}`}><AlertTriangle className="w-3 h-3" /> Divergente</span>}
              {f.paga
                ? <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700"><CheckCircle2 className="w-3.5 h-3.5" /> Paga</span>
                : <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-600"><Clock className="w-3.5 h-3.5" /> Em aberto</span>}
            </div>
            <ChevronDown className={`w-5 h-5 text-slate-300 transition-transform ${isOpen ? "rotate-180" : ""}`} />
          </div>
        </button>
      </div>
      {isOpen && (
        <div className="border-t border-slate-100 px-5 py-4 bg-slate-50/40 space-y-4">
          {periodo && (
            <p className="text-xs text-slate-500 flex items-center gap-1.5" data-testid={`fatura-periodo-${f.key}`}>
              <CalendarClock className="w-3.5 h-3.5 text-blue-500" /> Período de consumo do ciclo: <span className="font-semibold text-slate-700">{periodo}</span>
            </p>
          )}
          {mensalItens.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-slate-500 uppercase mb-1.5">Mensalidade e encargos</p>
              <table className="w-full text-sm"><tbody className="divide-y divide-slate-100">
                {mensalItens.map((e, i) => (<tr key={i}><td className="py-2 text-slate-700">{e.descricao}</td><td className="py-2 text-right font-medium text-slate-700">{formatBRL(e.valor)}</td></tr>))}
              </tbody></table>
            </div>
          )}
          {(f.itens.length > 0 || materiaisManual.length > 0) && (
            <div>
              <p className="text-xs font-semibold text-slate-500 uppercase mb-1.5">Materiais, medicamentos e serviços</p>
              <table className="w-full text-sm"><tbody className="divide-y divide-slate-100">
                {f.itens.map((it2) => (<tr key={it2.id}><td className="py-2 text-slate-500 w-24">{formatDate(it2.data)}</td><td className="py-2 text-slate-700">{getProduto(it2.produtoId)?.nome} <span className="text-slate-400">· {it2.qtdEmpresa} un</span></td><td className="py-2 text-right font-medium text-slate-700">{formatBRL(it2.valorCobrado)}</td></tr>))}
                {materiaisManual.map((m) => (<tr key={m.id}><td className="py-2 text-slate-400 w-24">manual</td><td className="py-2 text-slate-700">{m.descricao}</td><td className="py-2 text-right font-medium text-slate-700">{formatBRL(m.valor)}</td></tr>))}
              </tbody></table>
            </div>
          )}
          {f.observacao && (<p className="text-xs text-slate-500 bg-white border border-slate-100 rounded-lg px-3 py-2"><span className="font-semibold">Obs.:</span> {f.observacao}</p>)}
          {isAdmin && <HistoricoBoletos eventos={eventosBoleto} faturaKey={f.key} residenteId={f.residenteId} />}
          <div className="flex items-center justify-between pt-3 border-t border-slate-200 flex-wrap gap-2">
            <span className="font-semibold text-slate-800">Total: {formatBRL(f.total)}</span>
            {divergente && (
              <div className="w-full mt-2 text-xs rounded-lg border border-amber-200 bg-amber-50 text-amber-900 px-3 py-2 flex items-start gap-2" data-testid={`divergencia-alerta-${f.key}`}>
                <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" />
                <span><b>Valor do boleto diferente da fatura calculada.</b> Boleto emitido: <b>{formatBRL(f.totalBoleto)}</b> · Fatura calculada hoje: <b>{formatBRL(f.totalCalculado)}</b> (diferença {formatBRL(f.totalBoleto - f.totalCalculado)}). Isso ocorre quando a mensalidade, serviços ou consumos mudaram após a emissão. Use <b>Gerar novamente</b> para reemitir com o valor correto (o boleto anterior é cancelado automaticamente) ou <b>Cancelar boleto</b>.</span>
              </div>
            )}
            <div className="flex items-center gap-2 flex-wrap">
              {f.cancelada ? (
                <Button variant="outline" className="gap-2 text-emerald-700 border-emerald-200 hover:bg-emerald-50" onClick={() => restaurar(f)} data-testid={`restaurar-fatura-${f.key}`}><CheckCircle2 className="w-4 h-4" /> Restaurar fatura</Button>
              ) : (
                <>
                  <Button variant="outline" className="gap-2" onClick={() => abrirEdicao(f)} data-testid={`editar-fatura-${f.key}`}><Pencil className="w-4 h-4" /> Editar</Button>
                  <Button variant="outline" className="gap-2" onClick={() => baixarPdf(f, res)} data-testid={`pdf-fatura-${f.key}`}><FileDown className="w-4 h-4" /> Gerar PDF</Button>
                  <Button variant="outline" className="gap-2 text-emerald-700 border-emerald-200 hover:bg-emerald-50" disabled={enviandoWa === f.key} onClick={() => enviarWa(f)} data-testid={`whatsapp-fatura-${f.key}`}><MessageCircle className="w-4 h-4" /> {enviandoWa === f.key ? "Enviando..." : "WhatsApp"}</Button>
                  <Button variant="outline" className="gap-2 text-emerald-700 border-emerald-200 hover:bg-emerald-50" disabled={enviandoPdf === f.key} onClick={() => enviarWaPdf(f)} data-testid={`whatsapp-pdf-fatura-${f.key}`}><MessageCircle className="w-4 h-4" /> {enviandoPdf === f.key ? "Enviando..." : "PDF WhatsApp"}</Button>
                  {!f.paga && <Button variant="outline" className="gap-2 text-emerald-700 border-emerald-200 hover:bg-emerald-50" onClick={() => setPixOpen(true)} data-testid={`pix-fatura-${f.key}`}><QrCode className="w-4 h-4" /> Pix</Button>}
                  {isAdmin && !f.paga && (
                    bol ? (
                      <div className="flex items-center gap-2 flex-wrap" data-testid={`boleto-gerado-${f.key}`}>
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 text-xs font-medium">
                          <CheckCircle2 className="w-3.5 h-3.5" /> Boleto já gerado{bol.criadoEm ? ` em ${formatDate(String(bol.criadoEm).slice(0, 10))}` : ""}
                        </span>
                        {bol.sandbox && (
                          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 text-[11px] font-medium" title="Boleto criado no ambiente de TESTES (Sandbox) do Asaas — não aparece na conta real." data-testid={`boleto-sandbox-${f.key}`}>
                            <AlertTriangle className="w-3 h-3" /> ambiente de teste
                          </span>
                        )}
                        {(bol.invoiceUrl || bol.bankSlipUrl) && (
                          <a href={bol.invoiceUrl || bol.bankSlipUrl} target="_blank" rel="noreferrer" className="text-xs text-blue-600 hover:underline inline-flex items-center gap-1" data-testid={`ver-boleto-${f.key}`}><ExternalLink className="w-3.5 h-3.5" /> Ver boleto</a>
                        )}
                        <Button variant="ghost" size="sm" className="gap-1.5 text-slate-500 hover:text-blue-700" disabled={gerandoBoleto === f.key} onClick={() => { if (window.confirm("Este boleto já foi gerado. Gerar novamente CANCELA o boleto atual no Asaas e cria uma nova cobrança com o valor atualizado, enviando ao responsável. Deseja continuar?")) gerarBoleto(f); }} data-testid={`regerar-boleto-fatura-${f.key}`}><Landmark className="w-3.5 h-3.5" /> {gerandoBoleto === f.key ? "Gerando..." : "Gerar novamente"}</Button>
                        <Button variant="ghost" size="sm" className="gap-1.5 text-slate-500 hover:text-red-700" disabled={cancelandoBoleto === f.key || gerandoBoleto === f.key} onClick={() => cancelarBoleto(f)} data-testid={`cancelar-boleto-fatura-${f.key}`}><Ban className="w-3.5 h-3.5" /> {cancelandoBoleto === f.key ? "Cancelando..." : "Cancelar boleto"}</Button>
                      </div>
                    ) : rescisao ? (
                      <Button className="gap-2 bg-orange-600 hover:bg-orange-700" onClick={() => setAprovarOpen(true)} data-testid={`aprovar-rescisao-fatura-${f.key}`}><Landmark className="w-4 h-4" /> Aprovar e emitir boleto</Button>
                    ) : (
                      <>
                        {res?.formaCobranca === "pix" && (
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 text-xs font-medium" title="Residente configurado para cobrança via Pix: a rotina automática não emite boleto no Asaas." data-testid={`cobranca-pix-${f.key}`}>Pix manual (sem boleto automático)</span>
                        )}
                        <Button variant="outline" className="gap-2 text-blue-700 border-blue-200 hover:bg-blue-50" disabled={gerandoBoleto === f.key} onClick={() => gerarBoleto(f)} data-testid={`gerar-boleto-fatura-${f.key}`}><Landmark className="w-4 h-4" /> {gerandoBoleto === f.key ? "Gerando..." : "Gerar boleto + enviar"}</Button>
                      </>
                    )
                  )}
                  {f.paga
                    ? <Button variant="outline" onClick={() => marcarFaturaPaga(f.key, false)}>Reabrir</Button>
                    : (<>
                      <Button variant="outline" className="gap-2 text-emerald-700 border-emerald-200 hover:bg-emerald-50" onClick={() => setBaixaPixOpen(true)} data-testid={`baixa-pix-fatura-${f.key}`}><QrCode className="w-4 h-4" /> Baixa via Pix</Button>
                      <Button className="bg-emerald-600 hover:bg-emerald-700 gap-2" onClick={() => marcarFaturaPaga(f.key, true)} data-testid={`pagar-fatura-${f.key}`}><CheckCircle2 className="w-4 h-4" /> Marcar como paga</Button>
                    </>)}
                  <Button variant="outline" className="gap-2 text-red-600 border-red-200 hover:bg-red-50" onClick={() => setExcluirAlvo(f)} data-testid={`excluir-fatura-${f.key}`}><Trash2 className="w-4 h-4" /> Excluir</Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ---------- Card de RECEBÍVEL avulso ----------
const ReceberCard = ({ it, expanded, setExpanded, abrirReceber, marcarRecebido, excluirContaReceber, verAnexo, toast, recBusy }) => {
  const c = it.conta;
  const isOpen = expanded === it.key;
  const busy = recBusy === c.id;
  const vencida = c.status === "pendente" && c.vencimento && c.vencimento < hoje();
  return (
    <div className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden" data-testid={`rec-row-${c.id}`}>
      <button onClick={() => setExpanded(isOpen ? null : it.key)} className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50/60 transition-colors">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><HandCoins className="w-5 h-5" /></div>
          <div className="text-left">
            <p className="font-semibold text-slate-800 flex items-center gap-2">
              {c.descricao}
              <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded">Avulso</span>
              {c.recorrente && <span className="text-[10px] text-violet-700 bg-violet-50 px-1.5 py-0.5 rounded">Recorrente</span>}
              {c.parcelaTotal > 1 && <span className="text-[10px] text-blue-700 bg-blue-50 px-1.5 py-0.5 rounded">Parcela {c.parcelaNum}/{c.parcelaTotal}</span>}
            </p>
            <p className="text-xs text-slate-400 flex items-center gap-1"><CalendarClock className="w-3.5 h-3.5" /> {c.categoria}{c.pagador ? ` · ${c.pagador}` : ""} · Venc. {formatDate(c.vencimento)}</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="font-bold text-slate-800">{formatBRL(c.valor)}</p>
            {c.status === "recebido"
              ? <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700"><CheckCircle2 className="w-3.5 h-3.5" /> Recebido</span>
              : <span className={`inline-flex items-center gap-1 text-xs font-semibold ${vencida ? "text-red-600" : "text-amber-600"}`}><Clock className="w-3.5 h-3.5" /> {vencida ? "Vencido" : "A receber"}</span>}
          </div>
          <ChevronDown className={`w-5 h-5 text-slate-300 transition-transform ${isOpen ? "rotate-180" : ""}`} />
        </div>
      </button>
      {isOpen && (
        <div className="border-t border-slate-100 px-5 py-4 bg-slate-50/40 space-y-3">
          {c.observacoes && (<p className="text-xs text-slate-500 bg-white border border-slate-100 rounded-lg px-3 py-2"><span className="font-semibold">Obs.:</span> {c.observacoes}</p>)}
          {c.status === "recebido" && c.dataRecebimento && (<p className="text-xs text-emerald-700">Recebido em {formatDate(c.dataRecebimento)}</p>)}
          <div className="flex items-center justify-between pt-2 border-t border-slate-200 flex-wrap gap-2">
            <span className="font-semibold text-slate-800">Total: {formatBRL(c.valor)}</span>
            <div className="flex items-center gap-2 flex-wrap">
              {c.comprovante && <Button variant="outline" className="gap-2" onClick={() => verAnexo(c.comprovante)} data-testid={`rec-comprovante-${c.id}`}><Paperclip className="w-4 h-4" /> Comprovante</Button>}
              <Button variant="outline" className="gap-2" onClick={() => abrirReceber(c)} data-testid={`rec-editar-${c.id}`}><Pencil className="w-4 h-4" /> Editar</Button>
              {c.status === "recebido"
                ? <Button variant="outline" disabled={busy} onClick={() => marcarRecebido(c, false)} data-testid={`rec-reabrir-${c.id}`}>{busy ? "..." : "Reabrir"}</Button>
                : <Button className="bg-emerald-600 hover:bg-emerald-700 gap-2" disabled={busy} onClick={() => marcarRecebido(c, true)} data-testid={`rec-receber-${c.id}`}><CheckCircle2 className="w-4 h-4" /> {busy ? "..." : "Marcar como recebido"}</Button>}
              <Button variant="outline" className="gap-2 text-red-600 border-red-200 hover:bg-red-50" onClick={async () => { await excluirContaReceber(c.id); toast({ title: "Recebível excluído" }); }} data-testid={`rec-excluir-${c.id}`}><Trash2 className="w-4 h-4" /> Excluir</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Faturas;
